export const placeholders = {
  line_1: "Camfield House",
  line_2: "Avenue Road",
  city: "Letchworth",
  county: "Hertfordshire",
  postcode: "SG6 2WW",

  marketingSource: "Google",

  notes: "Write your notes here...",

  companyName: "Fortus Group Ltd",

  name: "John Smith",
}
